import { useEffect } from "react";
import reqVideos from "../../../services/reqVideos";
import api from "../../../services/api";
import { useState } from "react";
import Notification from "../../../components/toast";
import CardModulos from "../../../components/cards/modulos";
import Footer from "../../../components/footer";
import { ToastContainer } from "react-toastify";
import CardGrupo from "../../../components/cards/grupo";
import { useNavigate } from "react-router-dom";
import Loading from "../../../components/loading";

export default function ModulosVideos() {
	const [listModulos, setListModulos] = useState([]);
	const [listGrupo, setListGrupo] = useState([]);
	const [moduloSelecionado, setModuloSelecionado] = useState("");
	const [onLoading, setOnLoading] = useState(false);

	const navigate = useNavigate();

	useEffect(() => {
		ListarModulos();
	}, []);

	async function ListarModulos() {
		try {
			try {
				setOnLoading(true);
				const result = await reqVideos.modulos(api);

				setListModulos(result.data);

				setListGrupo([]);
			} catch (error) {
				Notification.showToast({ message: error.message, type: "warning" });
			}
		} finally {
			setOnLoading(false);
		}
	}

	async function handleCardModuloClick(id_modulo, modulo) {
		try {
			try {
				setOnLoading(true);
				const result = await reqVideos.grupos(api, id_modulo);
				setModuloSelecionado(modulo);
				setListGrupo(result.data);
			} catch (error) {
				Notification.showToast({ message: error.message, type: "warning" });
			}
		} finally {
			setOnLoading(false);
		}
	}

	async function handleCardGrupoClick(id_modulo, identificador) {
		try {
			const result = await reqVideos.grupos(api, id_modulo);
			window.location.href = `/videos/${identificador}`;
			//	navigate(`/videos/${identificador}`);
		} catch (error) {
			Notification.showToast({ message: error.message, type: "warning" });
		}
	}

	function LimparGrupo() {
		setListGrupo([]);
	}

	return (
		<div className="container-fluid mt-5">
			<ToastContainer />

			{onLoading ? (
				<Loading mensagem="Aguarde carregando vídeos ... " />
			) : listGrupo?.length > 0 ? (
				<div className="row">
					<div className="d-flex justify-content-between align-items-center">
						<h3 className="ms-4 mt-4">Tutoriais</h3>
						<button className="btn btn-sm btn-primary" onClick={(e) => LimparGrupo()}>
							Voltar
						</button>
					</div>
					<small className="ms-4 text-secondary">{`Selecione qual tela do ${moduloSelecionado}`}</small>

					{listGrupo.map((grupo, index) => {
						return (
							<CardGrupo //
								key={index}
								id_modulo={grupo.id_modulo}
								descricao={grupo.descricao}
								url_foto={grupo.url_foto}
								identificador={grupo.identificador}
								onClick={handleCardGrupoClick}
							/>
						);
					})}
				</div>
			) : (
				<div className="row align-items-center justify-content-center">
					<h3 className="ms-4 mt-4">Tutoriais</h3>
					<small className="ms-4 text-secondary">Selecione o módulo para ver os vídeos</small>
					{listModulos.map((modulo, index) => {
						return (
							<CardModulos //
								key={index}
								id_modulo={modulo.id_modulo}
								descricao={modulo.descricao}
								url_foto={modulo.url_foto}
								onClick={handleCardModuloClick}
							/>
						);
					})}
				</div>
			)}

			<footer>
				<Footer />
			</footer>
		</div>
	);
}
